const MINUTES_TO_MS = 60 * 1000;

export const DURATION_OPTIONS = [
    { label: '5 minutes', value: 5 * MINUTES_TO_MS },
    { label: '10 minutes', value: 10 * MINUTES_TO_MS },
    { label: '15 minutes', value: 15 * MINUTES_TO_MS },
    { label: '20 minutes', value: 20 * MINUTES_TO_MS },
    { label: '25 minutes', value: 25 * MINUTES_TO_MS },
    { label: '30 minutes', value: 30 * MINUTES_TO_MS },
    { label: '45 minutes', value: 45 * MINUTES_TO_MS },
    { label: '1 hour', value: 60 * MINUTES_TO_MS },
    { label: '1 hour 30 minutes', value: 90 * MINUTES_TO_MS },
    { label: '2 hours', value: 120 * MINUTES_TO_MS },
];

export const BUFFER_TIME_OPTIONS = [
    { label: 'None', value: 0 },
    { label: '5 minutes', value: 5 * MINUTES_TO_MS },
    { label: '10 minutes', value: 10 * MINUTES_TO_MS },
    { label: '15 minutes', value: 15 * MINUTES_TO_MS },
    { label: '20 minutes', value: 20 * MINUTES_TO_MS },
    { label: '25 minutes', value: 25 * MINUTES_TO_MS },
    { label: '30 minutes', value: 30 * MINUTES_TO_MS },
    { label: '45 minutes', value: 45 * MINUTES_TO_MS },
    { label: '1 hour', value: 60 * MINUTES_TO_MS },
];

export const LEAD_TIME_OPTIONS = [
    { label: 'None', value: 0 },
    { label: '5 minutes', value: 5 * MINUTES_TO_MS },
    { label: '10 minutes', value: 10 * MINUTES_TO_MS },
    { label: '15 minutes', value: 15 * MINUTES_TO_MS },
    { label: '20 minutes', value: 20 * MINUTES_TO_MS },
    { label: '25 minutes', value: 25 * MINUTES_TO_MS },
    { label: '30 minutes', value: 30 * MINUTES_TO_MS },
    { label: '45 minutes', value: 45 * MINUTES_TO_MS },
    { label: '1 hour', value: 60 * MINUTES_TO_MS },
    { label: '2 hours', value: 120 * MINUTES_TO_MS },
    { label: '6 hours', value: 360 * MINUTES_TO_MS },
    { label: '1 day', value: 1440 * MINUTES_TO_MS },
];

/**
 * No limit, and 1-20 meetings per day
 */
export const MAX_MEETINGS_OPTIONS = [
    { label: 'No limit', value: 0 },
    ...Array.from(Array(21).keys())
        .slice(1)
        .map(value => ({
            value,
            label: `${value} meeting${value === 1 ? '' : 's'} per day`,
        })),
];
